import React, { useCallback } from 'react';
import { Select } from 'modules/filters/utils';
import * as http from 'utils/http';
import config from 'config';
import { injectIntl } from 'react-intl';

const format = (shippers = []) =>
  shippers.map(({ company_name, id }) => ({
    label: company_name,
    value: id,
  }));

const ShipperFilter = ({ value, onChange, className, intl }) => {
  const t = intl.messages.modules.Filters.shipper;
  const loadOptions = useCallback(async (input) => {
    if (!input || input.length < 3) {
      return Promise.resolve([{}]);
    }

    const shippers = await http.get(
      `${config.API_URL}mercury/shippers/?search=${input}&page_size=0&ordering=company_name`
    );

    if (shippers.length > 0) return format(shippers);

    const shippersWithUserEmails = await http.get(
      `${config.API_URL}mercury/shippers/?user_email=${input}&page_size=0`
    );

    return format(shippersWithUserEmails);
  }, []);

  const handleChange = useCallback(
    (change) => {
      onChange(change);
    },
    [onChange]
  );

  return (
    <div className={className} data-testid="shipper_filter">
      <Select
        isClearable
        value={value}
        onChange={handleChange}
        placeholder={t.placeholder}
        closeMenuOnSelect={false}
        async
        loadOptions={loadOptions}
      />
    </div>
  );
};

export default injectIntl(ShipperFilter);
